export default {
    intro: 'Hãy nhìn các gợi ý như phụ âm đầu, nghĩa, ví dụ<br />và suy luận xem đó là từ gì!',
    word: 'Từ',
    meaning: 'Nghĩa',
    example: 'Ví dụ',
    resources: 'Tài liệu',
    teacherFooter: { left: 'Vui lòng chọn từ trong câu hỏi bên trái.' },
    emptyExample: 'Không có câu ví dụ.',
    openExample: 'Khi công bố câu ví dụ, từ sẽ được công bố hoàn toàn.',
    introSelectWord: 'Hãy chọn từ ở bên trái để bắt đầu!',
    subExamplesExpand: 'Xem thêm câu ví dụ',
    subExamplesCollapse: 'Thu gọn',
    showInitial: 'Hiển thị phụ âm đầu',
    showAll: 'Hiển thị toàn bộ từ',
    show: 'Hiển thị',
    table: { question: 'Câu hỏi', emptyMessage: 'Không có nội dung.' },
    teacher: {
        modal: {
            clearConfirm: {
                title: 'Xóa tất cả từ vựng đang chờ?',
                message: 'Tất cả từ vựng đang chờ sẽ bị xóa. Tiếp tục?',
            },
            closeConfirm: {
                title: 'Hủy nội dung đã nhập?',
                message: 'Đóng sẽ xóa tất cả từ trong danh sách chờ. Tiếp tục?',
            },
            questionDelete: {
                title: 'Xóa câu hỏi này?',
                // {word}: từ đầu mục của câu hỏi cần xóa. Cảnh báo sẽ bị xóa vĩnh viễn khỏi hoạt động.
                message: "Câu hỏi '{word}' sẽ bị xóa khỏi hoạt động. Tiếp tục?",
            },
            waitItemDelete: {
                title: 'Xóa từ vựng đang chờ?',
                // {word}: từ vựng đang chờ cần xóa. Chỉ xóa khỏi hàng đợi; hoạt động không bị ảnh hưởng.
                message: "Xóa '{word}' khỏi danh sách chờ. Tiếp tục?",
            },
            // {count}: số từ bị bỏ qua do trùng lặp trong từ điển
            duplicateNotice: '{count} từ đã được đăng ký nên không được thêm.',
            // {count}: số từ bị bỏ qua vì không có nghĩa
            skippedNotice: '{count} từ không có nghĩa nên không được thêm.',
            // Xác nhận khi trộn lẫn từ không có nghĩa với từ hợp lệ
            mixedEmptyConfirm: {
                title: 'Đăng ký?',
                line1: '{empty} từ không có nghĩa sẽ không được thêm.',
                line2: 'Chỉ đăng ký {valid} từ còn lại?',
            },
            // Thông báo khi chỉ còn lại từ không có nghĩa
            onlyEmptyNotice: {
                title: 'Không thể đăng ký',
                message: 'Không có từ nào để đăng ký. Chỉ còn lại các từ không có nghĩa.',
            },
            registerFailed: 'Không thể thêm.',
        },
    },
};
